import React, { Component } from "react";
import { connect } from "react-redux";
import { ThumbsUpIcon, ThumbsDownIcon } from "../../assets/fontawesome"
import { emitWebSocketData } from "../../services/websocket";
import { sendEvaluation, setConversation } from "../../actions/message";

import "./rate-iteration.scss";

class RateIteration extends Component {
  state = {
    evaluation: "",
  };

  constructor(props) {
    super(props);
    this.hasEvaluation = this.hasEvaluation.bind(this);
  }

  handleClick = (e) => {
    this.setState({ evaluation: e.currentTarget.value });
    // this.props.sendEvaluation(e.currentTarget.value, this.props.id);
    const { interactionMachineId } = JSON.parse(
      localStorage.getItem("session-config") || "{}"
    );
    emitWebSocketData('evaluate-iteration-message', { value: e.currentTarget.value, id: interactionMachineId });
    const newMessages = this.props.messages;
    newMessages[this.props.position].iterationRate = e.currentTarget.value;
    this.props.setConversation(newMessages);
  };

  getEvaluation() {
    let positiveStyle = '#cccccc';
    let negativeStyle = '#cccccc';

    if (this.state.evaluation === "-1")
      negativeStyle = "rgba(244, 67, 54, 0.8)";
    if (this.state.evaluation === "1")
      positiveStyle = "rgba(77, 143, 1, 0.8)";

    return (
      <div className="evaluate-container">
        <button
          title="Gostei"
          name="positive"
          value="1"
          className="up"
          onClick={this.handleClick}
        >
          <ThumbsUpIcon color={positiveStyle} />
        </button>
        <button
          title="Não Gostei"
          name="negative"
          value="-1"
          className="down"
          onClick={this.handleClick}
        >
          <ThumbsDownIcon color={negativeStyle} />
        </button>
      </div>
    );
  }

  getEvaluated() {
    if (
      !this.state.evaluation &&
      (!this.props.action || this.props.action === "validate")
    )
      return false;

    let style = {};

    if (this.state.evaluation === "-1" || this.props.action === "negative")
      style = "rgba(244, 67, 54, 0.8)";
    if (this.state.evaluation === "1" || this.props.action === "positive")
      style = "rgba(77, 143, 1, 0.8)";

    return (
      <div className="evaluated-container">
        <div>
          {this.state.evaluation === "1" || this.props.action === "1" ? (
            <ThumbsUpIcon color={style} />
          ) : (
            <ThumbsDownIcon color={style} />
          )}
        </div>
      </div>
    );
  }

  hasEvaluation() {
    if (!this.props.action) return false;
    if (this.props.position === 0) return false;
    if (this.props.action === "no-evaluate") return false;
    return this.props.config.isInteractionRatingActive;
  }

  render() {
    if (!this.hasEvaluation()) return false;
    return this.props.messages.length - 1 === this.props.position
      ? this.getEvaluation()
      : this.getEvaluated();
  }
}

const mapStateToProps = (state) => ({
  messages: state.messages,
});

const mapDispatchToProps = (dispatch) => ({
  sendEvaluation: (index, type) => dispatch(sendEvaluation(index, type)),
  setConversation: (conversation) => dispatch(setConversation(conversation)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RateIteration);
